import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useBootstrap } from '../context/BootstrapContext.jsx';
import { usePageStyles } from '../hooks/usePageAssets.js';
import { resolveStaticUrl } from '../utils/staticAssets.js';
import AdminApp from '../components/admin/AdminApp.jsx';

const AdminPage = () => {
  const bootstrap = useBootstrap();
  const location = useLocation();
  const navigate = useNavigate();
  usePageStyles([resolveStaticUrl('css/style.css'), resolveStaticUrl('css/admin.css')]);

  // Ignora parámetros legacy y limpia la URL para evitar rutas obsoletas.
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    if (params.has('legacy')) {
      params.delete('legacy');
      navigate(
        {
          pathname: location.pathname,
          search: params.toString() ? `?${params.toString()}` : '',
          hash: location.hash
        },
        { replace: true }
      );
    }
  }, [location.pathname, location.search, location.hash, navigate]);

  if (!bootstrap?.authenticated || !bootstrap?.is_super_admin) {
    return (
      <div id="admin-page" className="admin-guard">
        <h2>Acceso restringido</h2>
        <p>Este panel es exclusivo para super administradores.</p>
        <a className="auth-btn" href={bootstrap?.routes?.login || '/login'}>
          Iniciar sesión
        </a>
      </div>
    );
  }

  return <AdminApp bootstrap={bootstrap} />;
};

export default AdminPage;
